
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","viewBox":"0 0 21 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M2.376 2a.75.75 0 01.75-.75h14.637a.75.75 0 01.75.75v16a.75.75 0 01-.75.75H3.126a.75.75 0 01-.75-.75v-2.45H2a.75.75 0 010-1.5h.376v-1.7H2a.75.75 0 010-1.5h.376v-1.7H2a.75.75 0 010-1.5h.376v-1.7H2a.75.75 0 010-1.5h.376V2zm1.5 13.55h.376a.75.75 0 000-1.5h-.376v-1.7h.376a.75.75 0 000-1.5h-.376v-1.7h.376a.75.75 0 100-1.5h-.376v-1.7h.376a.75.75 0 100-1.5h-.376v-1.7h13.137v14.5H3.876v-1.7zM7.797 5.193a2.3 2.3 0 011.917 0c.301.138.57.338.792.584.222.246.395.534.512.845a2.787 2.787 0 010 1.956c-.117.311-.29.6-.512.845a2.438 2.438 0 01-1 .667v3.643a.75.75 0 11-1.5 0V10.09a2.438 2.438 0 01-1-.667 2.64 2.64 0 01-.513-.845 2.788 2.788 0 010-1.956c.117-.311.29-.6.512-.845.223-.246.491-.446.792-.584zm.958 1.29a.8.8 0 00-.334.074.939.939 0 00-.304.226c-.09.101-.167.225-.22.366a1.288 1.288 0 000 .902c.053.141.13.265.22.366.092.1.196.176.304.226a.8.8 0 00.669 0 .939.939 0 00.304-.226c.09-.101.167-.225.22-.366a1.288 1.288 0 000-.902 1.14 1.14 0 00-.22-.366.939.939 0 00-.304-.226.8.8 0 00-.335-.074zm5.254 3.582a1.88 1.88 0 00.562-.366c.356-.337.564-.804.564-1.299V5.733a.75.75 0 00-1.5 0V8.4a.29.29 0 01-.095.21.409.409 0 01-.28.107.409.409 0 01-.281-.107.29.29 0 01-.096-.21V5.733a.75.75 0 00-1.5 0V8.4c0 .495.208.962.564 1.299.166.156.357.28.562.366v3.668a.75.75 0 101.5 0v-3.668z"}})])
          )
        }
      }
    